// Enregistrement du service worker — uniquement en production, comme le
// veut le pattern standard CRA (en dev, un SW en cache gênerait le hot-reload).

export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((error) => {
      console.error('Échec de l\'enregistrement du service worker :', error);
    });
  });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready.then((registration) => {
    registration.unregister();
  });
}

// Purge défensive en dev : un service worker installé lors d'un test de
// build de prod servi en local reste actif indéfiniment tant qu'il n'est
// pas explicitement désinscrit (le NODE_ENV !== 'production' de register()
// ci-dessus empêche seulement d'en ENREGISTRER un nouveau, pas de retirer un
// ancien déjà présent) — il continue alors à servir un bundle figé et masque
// tous les changements de code suivants, y compris après F5/Ctrl+Shift+R.
export function unregisterAllInDev() {
  if (process.env.NODE_ENV === 'production') return;
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister());
    });
  }
  if ('caches' in window) {
    caches.keys().then((names) => names.forEach((name) => caches.delete(name)));
  }
}
